import { useEffect } from "react";

export const useChromeBrowserDetection = () => {
    useEffect(() => {
        // Check if navigator and userAgent are available
        if (typeof navigator === "undefined" || !navigator.userAgent) {
            return;
        }

        const userAgent = navigator.userAgent;
        const isIOS = /iPad|iPhone|iPod/.test(userAgent);
        const isChrome = /CriOS/.test(userAgent);

        if (isIOS && isChrome) {
            document.body?.classList.add("chrome-ios");
        }

        return () => {
            document.body?.classList.remove("chrome-ios");
        };
    }, []);
};
